<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          صفحه یافت نشد
        </h2>
        <b-button variant="primary" class="mb-2" to="/">
          بازگشت به صفحه اصلی
        </b-button>

        <!-- image -->
        <b-img fluid src="@/assets/images/pages/error-dark.svg" alt="Error page" />
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BButton, BImg } from 'bootstrap-vue';

export default {
  components: {
    BButton,
    BImg,
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
